import { Component, OnInit } from '@angular/core';
import { ReportService } from '../report.service';
import { CategoryService } from '../../categories/category.service';
import { ContractorService } from '../../contractors/contractor.service';
import { CityService } from '../../cities/city.service';
import { StoreService } from '../../stores/store.service';
import { Message } from 'primeng/primeng';


import { error } from 'selenium-webdriver';



@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css'],
  providers: [
    ReportService,
    CategoryService,
    ContractorService,
    CityService,
    StoreService
  ]
})
export class ReportComponent implements OnInit {

  reports:any =[];
  msgs: Message[] = [];

  selectedReport:string ="";
  selectedCategory: string[] = [];
  selectedContractor: string[] = [];
  selectedCity: string[] = [];
  selectedStore: string;
  date_start:string="";
  date_finish:string="";
  filter:any=[];
  isExport:boolean=false;
  loading:boolean=false;
  progressBar:boolean=false;
  filterDisplay:boolean=false;
  filterButtonVisible:boolean=false;
  contractorDropdownVisible: boolean=true;
  categoryDropdownVisible: boolean=true;
  cityDropdownVisible: boolean=true;
  storeDropdownVisible: boolean=true;
  generateButtonVisible:boolean=true;
  categoryFetch: any = [];
  categories:any=[];
  contractors:any=[];
  cities:any=[];
  stores: any = [];
  reportsData:any=[];
  cols: any[];
  constructor(
    private reportService: ReportService,
    private categoryService: CategoryService,
    private contractorService: ContractorService,
    private cityService: CityService,
    private storeService: StoreService
  ) { }

  ngOnInit() {
    this.reports.push({label: 'Отчет по остаткам на складе', value: {name: 'product-storage', id: 1, cols:  [
      {field: '№', header: '№'},
      {field: 'Код', header: 'Код'},
      {field: 'Наименование товаров', header: 'Наименование товаров'},
      {field: 'Кол-во', header: 'Кол-во'},
      {field: 'Ед изм', header: 'Ед. изм.'},
      {field: 'Вес(кг)', header: 'Вес(кг)'},
      {field: 'Общая сумма', header: 'Общая сумма'},
     ]} });

    this.reports.push({label: 'Оповещения о дне рождении компании', value: {name: 'contacts-by-date-of-birth', id: 2, cols:  [
      {field: '№', header: '№'},
      {field: 'Компания', header: 'Компания'},
      {field: 'Контакт', header: 'Контакт'},
      {field: 'Телефон', header: 'Телефон'},
      {field: 'Дата рождения', header: 'Дата рождения'},
     ]}  });

    this.reports.push({label: 'Отчет об оплате долга', value: {name: 'pay-in-debt', id: 3,cols:  [
      {field: '№', header: '№'},
      {field: 'Компания', header: 'Компания'},
      {field: '№ Накладной', header: '№ Накладной'},
      {field: 'Дата покупки', header: 'Дата покупки'},
      {field: 'Дата погашения', header: 'Дата погашения'},
      {field: 'Сумма долга', header: 'Сумма долга'},
      {field: 'Текущее сальдо', header: 'Текущее сальдо'},
      {field: 'Контакт', header: 'Контакт'},
      {field: 'Телефон', header: 'Телефон'},
     ]}  });

    this.reports.push({label: 'Общий отчет по реализации товаров', value: {name: 'sold-group-products-by-category', id: 4,cols:  [
      {field: '№', header: '№'},
      {field: 'Продукция', header: 'Продукция'},
      {field: 'Количество (шт)', header: 'Количество (шт)'},
      {field: 'Общий вес (кг)', header: 'Общий вес (кг)'},
      {field: 'Общая сумма', header: 'Общая сумма'},
      {field: 'Город (Регион)', header: 'Город (Регион)'},
      {field: 'Клиент', header: 'Клиент'},
    ]}  });

    this.reports.push({label: 'Отчет о реализации товаров c параметрами', value: {name: 'sold-group-products-by-params', id: 5, cols:  [
      {field: '№', header: '№'},
      {field: 'Код', header: 'Код'},
      {field: 'Наименование товара', header: 'Наименование товара'},
      {field: 'Осн ед изм', header: 'Осн. ед. изм.'},
      {field: 'Кол-во', header: 'Кол-во'},
      {field: 'Дет ед изм', header: 'Дет. ед. изм'},
      {field: 'Кол-во', header: 'Кол-во'},
      {field: 'Вес 1 ед(кг)', header: 'Вес 1 ед.(кг)'},
      {field: 'Общий вес(кг)', header: 'Общий вес(кг)'},
      {field: 'Цена', header: 'Цена'},
      {field: 'Сумма', header: 'Вес(кг)'},
      {field: 'Город', header: 'Город'},
      {field: 'Клиент', header: 'Клиент'},
     ]} });

     this.reports.push({label: 'Отчет по отпуску на складе', value: {name: 'sale-and-defective_products', id: 6, cols:  [
      {field: '№', header: '№'},
      {field: 'Код', header: 'Код'},
      {field: 'Наименование товара', header: 'Наименование товара'},
      {field: 'Ед изм', header: 'Ед. изм.'},
      {field: 'Реализовано', header: 'Реализовано'},
      {field: 'Списано', header: 'Списано'},
      {field: 'Причина', header: 'Причина'},
      {field: 'Отпущено', header: 'Отпущено'},
      {field: 'Общий вес(кг)', header: 'Общий вес(кг)'},
      {field: 'Цена', header: 'Цена'},
      {field: 'Сумма', header: 'Сумма'},
     ]} });
     this.reports.push({label: 'Отчет по поступлениям денег', value: {name: 'replenishment-account', id: 7, cols:  [
      {field: '№', header: '№'},
      {field: 'Клиент', header: 'Клиент'},
      {field: 'Дата оплаты', header: 'Дата оплаты'},
      {field: 'Сумма', header: 'Сумма'},
      {field: 'Тип проводки', header: 'Тип проводки'},
      {field: 'Тип назначения', header: 'Тип назначения'},
      {field: 'Номер документа', header: 'Номер документа'},
      {field: 'Текущее сальдо', header: 'Текущее сальдо'},
      {field: 'Комментарии к оплате', header: 'Комментарии к оплате'},
     ]} });
     this.reports.push({label: 'Отчет по начислениям бонуса', value: {name: 'account-bonuses', id: 8, cols:  [
      {field: '№', header: '№'},
      {field: 'Клиент', header: 'Клиент'},
      {field: 'Название дочерного тарифа', header: 'Название дочерного тарифа'},
      {field: 'Общий вес', header: 'Общий вес'},
      {field: 'Общая сумма', header: 'Общая сумма'},
      {field: 'Сумма бонуса', header: 'Сумма бонуса'},
      {field: 'Статус', header: 'Статус'},
     ]} });
     this.reports.push({label: 'Отчет по поступлениям на склад', value: {name: 'received-group-products-by-params', id: 9, cols:  [
      {field: '№', header: '№'},
      {field: 'Код', header: 'Код'},
      {field: 'Наименование товара', header: 'Наименование товара'},
      {field: 'Осн ед изм', header: 'Осн ед изм'},
      {field: 'Кол-во', header: 'Кол-во'},
      {field: 'Дет ед изм', header: 'Дет ед изм'},
      {field: 'Кол-во дет', header: 'Кол-во'},
      {field: 'Общий вес(кг)', header: 'Общий вес(кг)'},
      {field: 'Цена', header: 'Цена'},
      {field: 'Сумма', header: 'Сумма'},
     ]} });
     this.reports.push({label: 'Отчет по операциям', value: {name: 'transactions', id: 10, cols:  [
      {field: '№', header: '№'},
      {field: 'Тип проводки', header: 'Тип проводки'},
      {field: 'Тип назначение', header: 'Тип назначение'},
      {field: 'Дата покупки', header: 'Дата покупки'},
      {field: 'Дебет', header: 'Дебет'},
      {field: 'Кредит', header: 'Кредит'},
      {field: 'Сальдо', header: 'Сальдо'},
      {field: 'Номер документа', header: 'Номер документа'},
      {field: 'Комментарий', header: 'Комментарий'},
      {field: 'Ответственный', header: 'Ответственный'},
     ]} });
     this.reports.push({label: 'Обороты по клиентам', value: {name: 'summary-transactions', id: 11, cols:  [
      {field: '№', header: '№'},
      {field: 'Клиенты', header: 'Клиенты'},
      {field: 'Остаток на начало', header: 'Остаток на начало'},
      {field: 'Отпущено товаров', header: 'Отпущено товаров'},
      {field: 'Оплачено', header: 'Оплачено'},
      {field: 'Остаток на конец', header: 'Остаток на конец'},
     ]} });
     this.reports.push({label: 'Оповещения заканчивающие товары', value: {name: 'min-count-notice-product', id: 12, cols:  [
      {field: '№', header: '№'},
      {field: 'Код', header: 'Код'},
      {field: 'Наименование товаров', header: 'Наименование товара'},
      {field: 'Кол-во', header: 'Кол-во'},
      {field: 'Мин кол-во', header: 'Мин кол-во'},
      {field: 'Ед изм', header: 'Ед изм'},
      {field: 'Вес(кг)', header: 'Вес(кг)'},
      {field: 'Общая сумма', header: 'Общая сумма'},
     ]} });
  }

  onGenerate(){

    if(this.prepareFilter()){

    this.reportsData=[];
    this.progressBar=true;
    if(!this.isExport){
      this.loading = true;
      this.cols=this.selectedReport['cols'];
    }
    this.reportService.getReport(this.selectedReport,this.isExport,this.filter).subscribe(response=>{
      if(this.isExport){
        var blob = this.b64toBlob(response['data']['file'],'application/vnd.ms-excel','');
        this.download(blob,response['data']['name']);
      }else{
        this.loading = false;
        this.reportsData=response['data'];
      }
      
      this.progressBar=false;

    },error=>{
      this.loading = false;
      this.progressBar=false;
    });

  }

  }

  onReportChange(){
    this.generateButtonVisible=false;
    switch (this.selectedReport['id']) {
      case 1: 
        this.filterButtonVisible=true;
        this.storeDropdownVisible=true;
        this.contractorDropdownVisible=false;
        this.categoryDropdownVisible=true;
        this.cityDropdownVisible=false;
        break;
      case 2:  case 3:
        this.filterButtonVisible=true;
        this.contractorDropdownVisible=false;
        this.categoryDropdownVisible=false;
        this.cityDropdownVisible=false;
        this.storeDropdownVisible=true;
        break;
      case 4:
        this.filterButtonVisible=true;
        this.contractorDropdownVisible=true;
        this.categoryDropdownVisible=true;
        this.cityDropdownVisible=true;
        this.storeDropdownVisible=true;
        break;
      case 5:
        this.filterButtonVisible=true;
        this.contractorDropdownVisible=true;
        this.categoryDropdownVisible=true;
        this.cityDropdownVisible=true;
        this.storeDropdownVisible=true;
        break;
      case 6:
        this.filterButtonVisible=true;
        this.contractorDropdownVisible=false;
        this.categoryDropdownVisible=true;
        this.cityDropdownVisible=false;
        this.storeDropdownVisible=true;
        break;
        case 7:
        this.filterButtonVisible=true;
        this.contractorDropdownVisible=false;
        this.categoryDropdownVisible=false;
        this.cityDropdownVisible=false;
        this.storeDropdownVisible=true;
        break;
        case 8:
        this.filterButtonVisible=true;
        this.contractorDropdownVisible=true;
        this.categoryDropdownVisible=false;
        this.cityDropdownVisible=false;
        this.storeDropdownVisible=true;
        break;
        case 9:
        this.filterButtonVisible=true;
        this.contractorDropdownVisible=false;
        this.categoryDropdownVisible=true;
        this.cityDropdownVisible=false;
        this.storeDropdownVisible=true;
        break;
        case 10:
        this.filterButtonVisible=true;
        this.contractorDropdownVisible=true;
        this.categoryDropdownVisible=false;
        this.cityDropdownVisible=false;
        this.storeDropdownVisible=true;
        break;
        case 11:
        this.filterButtonVisible=true;
        this.contractorDropdownVisible=true;
        this.categoryDropdownVisible=false;
        this.cityDropdownVisible=false;
        this.storeDropdownVisible=false;
        break;
        case 12:
        this.filterButtonVisible=true;
        this.contractorDropdownVisible=false;
        this.categoryDropdownVisible=true;
        this.cityDropdownVisible=false;
        this.storeDropdownVisible=true;
        break;
    }
  }

  prepareFilter(){
    this.filter=[];

    switch (this.selectedReport['id']) {

      case 1:
                if(this.selectedCategory.length<1){
                  this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в категорию!"});
                  return false;
                }
                if(!this.selectedStore){
                    this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в склад!"});
                    return false;
                }
      break;
      case 2: case 3:
                if(this.date_start.length<1 || this.date_finish.length<1){
                  this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Выберите дату для сформирование отчета!"});
                  return false;
                  }
                if(!this.selectedStore){
                    this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в склад!"});
                    return false;
                }
      break;
      case 4:  case 5:
                if(this.date_start.length<1 || this.date_finish.length<1){
                  this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Выберите дату для сформирование отчета!"});
                  return false; 
                }
                if(this.selectedCategory.length<1){
                  this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в категорию!"});
                  return false;
                }
                if(this.selectedCity.length<1 && this.selectedContractor.length<1){
                  this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в города или в клиент!"});
                  return false;
                }
                if(!this.selectedStore){
                  this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в склад!"});
                  return false;
              }
        break;
        case 6: case 9: 
              if(this.date_start.length<1 || this.date_finish.length<1){
                this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Выберите дату для сформирование отчета!"});
                return false;
                }
                if(this.selectedCategory.length<1){
                  this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в категорию!"});
                  return false;
                }
                if(!this.selectedStore){
                    this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в склад!"});
                    return false;
                }
      break;
        case 7:
                if(this.date_start.length<1 || this.date_finish.length<1){
                  this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Выберите дату для сформирование отчета!"});
                  return false;
                  }
                if(!this.selectedStore){
                    this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в склад!"});
                    return false;
                }
        break;
        case 8: case 10:
                if(this.date_start.length<1 || this.date_finish.length<1){
                  this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Выберите дату для сформирование отчета!"});
                  return false;
                  }
                  if(this.selectedContractor.length<1){
                    this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в  клиент!"});
                    return false;
                  }
                if(!this.selectedStore){
                    this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в склад!"});
                    return false;
                }
        break;
        case 11:
        if(this.date_start.length<1 || this.date_finish.length<1){
          this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Выберите дату для сформирование отчета!"});
          return false;
          }
          if(this.selectedContractor.length<1){
            this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в  клиент!"});
            return false;
          }
        break;
        case 12:
        if(!this.selectedStore){
          this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в склад!"});
          return false;
        }
        if(this.selectedCategory.length<1){
          this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Добавьте фильтр в категорию!"});
          return false;
        }
        break;
    }


    if(this.date_start.length>1){
      this.filter.push({name:'date_start',value:this.date_start});
    }

    if(this.date_finish.length>1){
      this.filter.push({name:'date_finish',value:this.date_finish});
    }

    if(this.selectedCategory){
      for(let i=0;i<this.selectedCategory.length;i++){
        this.filter.push({name:'category_ids[]',value:this.selectedCategory[i]});
      }
    }
    if(this.selectedContractor){
      for(let i=0;i<this.selectedContractor.length;i++){
        this.filter.push({name:'contractor_ids[]',value:this.selectedContractor[i]});
      }
    }
    if(this.selectedCity){
      for(let i=0;i<this.selectedCity.length;i++){
        this.filter.push({name:'city_ids[]',value:this.selectedCity[i]});
      }
    }
    if(this.selectedStore){
        this.filter.push({name:'store_id',value:this.selectedStore});
    }

    return true;
  }

  applyFilter(){
    this.filterDisplay=false;
  }

  onShowFilter(){
    this.filterDisplay = true;
    this.categoryFetch=[];
    this.categoryService.getCategory().subscribe(response=>{
      this.recarray(response['data'],'children',this);
       this.categories=this.categoryFetch.map(function(value: any){
                                    return {label:value.name, value: value.id};
                               });  
  //  this.loading=false;
   });

   this.storeService.getStore().subscribe(response=>{
     this.stores = response['data'].map(function(value){return {label: value.name, value: value.id}});
   })

   this.contractorService.getContractorList().subscribe(response => {
      this.contractors = response['data'].map(function (value) { return { label: value.name, value: value.id} } ); 
      // this.contractors.splice(0, 1); 
    });

    this.cityService.getCity().subscribe(response=> {
      this.cities=response['data'].map(function (value) { return { label: value.name, value: value.id} });
  });

  
  
}
  

  recarray(ar: any, searchfor: any,that: any) {
    ar.forEach(function(item: any,i: any,arr: any){
        if(item instanceof Object){
            if("children" in item){
               that.recarray(item['children'],searchfor,that)
            }
            that.categoryFetch.push(item);
        }
    });
}

  download(blob,fileName){
    let a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = fileName+".xls";
    document.body.appendChild(a);
    a.click(); 
  }


 b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/reports/report/report.component.ts